import styled from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const DropdownSkeleton = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  border-radius: 8px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin: auto;
    width: 100%;
    height: 100%;
  }
`
